module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-03.0108bba5.png";